const IP_API_URL = 'https://ipapi.co/json/?key=c5CTtYsq6TOebWvtSFkb0nsoNPUnkTMjQdUKwK3Az3m9FXHXg9';

/**
 * Shared country promise for Marketo visibility (Email_Opt_In__c, legal htmltext).
 * Empty ipinfoCountry matches "notEqual US" and shows the non-US opt-in.
 */
function getVisitorCountry() {
  if ( !window.__ironcladVisitorCountryPromise ) {
    window.__ironcladVisitorCountryPromise = fetch( IP_API_URL )
      .then( function ( response ) {
        if ( !response.ok ) {
          throw new Error( 'IP API returned ' + response.status );
        }
        return response.json();
      } )
      .then( function ( data ) {
        window.__ironcladVisitorCountry = data.country || '';
        return window.__ironcladVisitorCountry;
      } )
      .catch( function ( error ) {
        console.error( 'Error fetching geolocation from ipapi:', error );
        return '';
      } );
  }
  return window.__ironcladVisitorCountryPromise;
}

window.__ironcladGetVisitorCountry = getVisitorCountry;

/**
 * Hide or show every Email Opt In row. The report page embeds form 3272 twice
 * (footer and #download-now). Marketo's loadForm callback updates the first
 * form object only, so the popup copy keeps an empty country and stays visible.
 */
function syncIpinfoCountryDom( country ) {
  const hideOptIn = !country || country === 'US';

  document.querySelectorAll( '[name="ipinfoCountry"]' ).forEach( function ( input ) {
    if ( country && input.value !== country ) {
      input.value = country;
    }
  } );

  document.querySelectorAll( '[name="Email_Opt_In__c"]' ).forEach( function ( opt ) {
    const row = opt.closest( '.mktoFormRow' );
    if ( !row ) {
      return;
    }
    const nextDisplay = hideOptIn ? 'none' : '';
    if ( row.style.display !== nextDisplay ) {
      row.style.display = nextDisplay;
    }
  } );
}

window.__ironcladSyncIpinfoCountryDom = syncIpinfoCountryDom;

function resolvedCountry( country ) {
  if ( country ) {
    window.__ironcladVisitorCountry = country;
    return country;
  }
  return window.__ironcladVisitorCountry || '';
}

/**
 * Apply country to a Marketo form. Must run in loadForm callback when possible —
 * late setValues often will not re-hide Email_Opt_In__c after it has already shown.
 */
function applyIpinfoCountryToForm( form, country ) {
  country = resolvedCountry( country );

  const forms = [];
  if ( form && typeof form.setValues === 'function' ) {
    forms.push( form );
  }

  try {
    if ( window.MktoForms2 && typeof window.MktoForms2.allForms === 'function' ) {
      window.MktoForms2.allForms().forEach( function ( existing ) {
        if ( forms.indexOf( existing ) === -1 && typeof existing.setValues === 'function' ) {
          forms.push( existing );
        }
      } );
    }
  } catch ( e ) {
    // no-op
  }

  if ( country ) {
    forms.forEach( function ( existing ) {
      try {
        existing.setValues( {
          ipinfoCountry: country
        } );
      } catch ( e ) {
        // no-op
      }
    } );
  }

  syncIpinfoCountryDom( country );
  // Popup instance can finish painting after the loadForm callback returns.
  window.setTimeout( function () {
    syncIpinfoCountryDom( country );
  }, 0 );
  window.setTimeout( function () {
    syncIpinfoCountryDom( country );
  }, 400 );
}

window.__ironcladApplyIpinfoCountryToForm = applyIpinfoCountryToForm;

function resyncIpinfoCountrySoon() {
  const country = window.__ironcladVisitorCountry || '';
  [ 0, 50, 250, 800 ].forEach( function ( delay ) {
    window.setTimeout( function () {
      syncIpinfoCountryDom( window.__ironcladVisitorCountry || country );
    }, delay );
  } );
}

function watchDownloadPopupOptIn() {
  const popup = document.getElementById( 'download-now' );
  if ( !popup || popup.dataset.ironcladOptInWatch === '1' ) {
    return;
  }
  popup.dataset.ironcladOptInWatch = '1';

  const observer = new MutationObserver( function () {
    syncIpinfoCountryDom( window.__ironcladVisitorCountry || '' );
  } );
  observer.observe( popup, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [ 'class', 'style' ]
  } );
}

document.addEventListener( 'click', function ( event ) {
  const link = event.target.closest && event.target.closest( 'a[href="#download-now"]' );
  if ( !link ) {
    return;
  }
  resyncIpinfoCountrySoon();
}, true );

function setupFormInteractions() {
  let formContainer = document.querySelector( '.e-div--js-forms-common' );
  if ( !formContainer ) return;
  function handleInputEvent( e ) {
    let isInputField = ['INPUT', 'TEXTAREA', 'SELECT'].includes( e.target.tagName );
    if ( isInputField && e.target.classList.contains( 'mktoField' ) ) {
      e.target.closest( '.mktoFieldWrap' ).classList.add( 'active' );
    }
  }
  function handleFieldState( e ) {
    if ( e.target.classList.contains( 'mktoField' ) ) {
      let method = e.target.value === '' ? 'remove' : 'add';
      e.target.closest( '.mktoFieldWrap' ).classList[method]( 'active' );
    }
  }
  formContainer.addEventListener( 'input', handleInputEvent );
  formContainer.addEventListener( 'change', handleInputEvent );
  formContainer.addEventListener( 'focus', handleInputEvent, true );
  formContainer.addEventListener( 'blur', handleFieldState, true );
  formContainer.addEventListener( 'focusout', handleFieldState );
}

function markSpecialRows() {
  document.querySelectorAll( '.mktoFormRow' ).forEach( function( row ) {
    const next = row.nextElementSibling;
    if ( next && next.classList.contains( 'mktoFormRow' ) ) {
      const placeholder = next.querySelector( '.mktoPlaceholder' );
      if ( placeholder && placeholder.innerHTML.trim() === '' ) {
        let afterNext = next.nextElementSibling;
        while ( afterNext && !afterNext.classList.contains( 'mktoButtonRow' ) ) {
          afterNext = afterNext.nextElementSibling;
        }
        if ( afterNext && afterNext.classList.contains( 'mktoButtonRow' ) ) {
          row.classList.add( 'mktoFormRow-next-empty' );
          afterNext.classList.add( 'mktoButtonRow-previous-empty' );
        }
      }
    }
  } );
}

function whenMktoForms2Ready( callback ) {
  if ( typeof window.MktoForms2 !== 'undefined' ) {
    callback( window.MktoForms2 );
    return;
  }

  let tries = 0;
  const maxTries = 40; // ~10s at 250ms
  const timer = window.setInterval( function () {
    tries += 1;
    if ( typeof window.MktoForms2 !== 'undefined' ) {
      window.clearInterval( timer );
      callback( window.MktoForms2 );
      return;
    }
    if ( tries >= maxTries ) {
      window.clearInterval( timer );
    }
  }, 250 );
}

document.addEventListener( 'DOMContentLoaded', function () {
  setupFormInteractions();
  watchDownloadPopupOptIn();
} );

if ( document.readyState !== 'loading' ) {
  watchDownloadPopupOptIn();
}

whenMktoForms2Ready( function ( MktoForms2 ) {
  MktoForms2.whenReady( function () {
    markSpecialRows();
  } );
} );

// Fallback for forms not loaded via embedded multi-instance loadForm hooks.
getVisitorCountry().then( function ( country ) {
  whenMktoForms2Ready( function ( MktoForms2 ) {
    MktoForms2.whenReady( function ( form ) {
      applyIpinfoCountryToForm( form, country );
    } );
  } );
} );
